import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';

import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';

import { WithContext as ReactTags } from 'react-tag-input';
import { Modal, ModalBody, ModalFooter, Button} from 'reactstrap';

import QRCode from 'qrcode.react';
import {IMGIX_PATH, PUB_PLAYER_PATH, UNPUB_PLAYER_PATH, BUILDER_PATH} from "../../constants";
import UploadFile from '../includes/UploadFile';
import Loader from 'react-loader-spinner';
import Analytics from "../common/Analytics";
import AuthService from '../../lib/AuthService';
import {Collapse} from 'react-bootstrap'
const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class DetailContainer extends Component {

    constructor(props) {
        super(props);


        this.state = {
            value: '',
            textNote : '',
            showPop : false,
            showQR : false,
            copyUrl : false,
            vignetTags : [],
            newTag : '',
            image_path: null,
            showShareOptions : false
        };
        this.Auth = new AuthService();
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.showSharePop = this.showSharePop.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.qToggle = this.qToggle.bind(this);
        this.cToggle = this.cToggle.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
        this.downloadQRCode = this.downloadQRCode.bind(this);
        this.saveTags = this.saveTags.bind(this);
        this.toggle = this.toggle.bind(this);

    }

    componentWillMount() {

    }

    componentDidMount() {

        let data = { userid : this.Auth.getProfile().user_id, 'le_id' : this.props.match.params.id  };
        this.props.getDetail(data);

        this.setState({vignet_id: this.props.match.params.id});

        let prop_params = { vignet_id : this.props.match.params.id, section : 'detail', index : 0 , section_name : 'detail' };
        // console.log(data)
        this.props.getVignetsProps(prop_params);

        let vig_params = { vigid : this.props.match.params.id };
        // console.log(data)
        this.props.getVignetTags(vig_params);

        let prj_params = { vigid : this.props.match.params.id };
        // console.log(data)
        this.props.getVignetProjects(prj_params);

        // console.log(data)
        this.props.getVignetNotes(vig_params);


    }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):

        if (this.props.vignetsData.vignetTags !== prevProps.vignetsData.vignetTags) {
            this.setState(
                {
                    tags: this.props.vignetsData.vignetTags,
                    tagStatus     : "Save"
                }
            );
        }

        if (this.props.vignetsData.vignetProjects !== prevProps.vignetsData.vignetProjects) {
            this.setState(
                {
                    projects: this.props.vignetsData.vignetProjects,
                    projectStatus     : "Save"
                }
            );
        }

        if ( this.props.vignetsData.tagsAdded !== prevProps.vignetsData.tagsAdded || this.props.vignetsData.tagsRemoved !== prevProps.vignetsData.tagsRemoved ){

            let vig_params = { vigid : this.props.match.params.id };
            // console.log(data)
            this.props.getVignetTags(vig_params);
            this.setState({editTag : false});
        }

        if ( this.props.vignetsData.projectAdded !== prevProps.vignetsData.projectAdded || this.props.vignetsData.projectRemoved !== prevProps.vignetsData.projectRemoved ){

            let prj_params = { vigid : this.props.match.params.id };
            // console.log(data)
            this.props.getVignetProjects(prj_params);
            this.setState({editProject : false});
        }

        if ( this.props.vignetsData.noteAdded !== prevProps.vignetsData.noteAdded ){
            let vig_params = { vigid : this.props.match.params.id };
            this.props.getVignetNotes(vig_params);
        }

        if(this.props.playlistData.newImage !== prevProps.playlistData.newImage ) {
            this.setState({image_path : this.props.playlistData.newImage});
        }

    }


    forceUpdateHandler(){
        let data = { userid : this.Auth.getProfile().user_id ,'le_id' : this.props.match.params.id };
        this.props.getDetail(data);
    }

    editTags() {
        this.setState({editTag : true});
    }

    editProjects() {
        this.setState({editProject : true});
    }

    cancelEdit(){
        this.setState({editTag : false});
    }
    cancelProjectEdit(){
        this.setState({editProject : false});
    }


    handleDelete(i) {
        let tags  = this.state.tags;
        console.log(tags);
        if(tags) {

            let newTags = tags.filter((tag, index) => index !== i);
            this.setState({
                tags: newTags
            });

            let data = {le_id : this.state.vignet_id, tag_name : tags[i].text, tags: JSON.stringify(newTags)};
            this.props.removeTags(data);
        }

    }

    handleAddition(tag) {
        console.log(this.state.tags);
        this.setState(state => ({ tags: [...state.tags, tag] }));

        let data = {le_id : this.state.vignet_id, tag_name : tag.text};
        this.props.saveTags(data);

        this.setState({tagStatus : "Processing..."})
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    handleInputBlur(tagText) {
        console.log(this.state.tags);
        this.setState({ newTag: tagText });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    saveTags() {
        if(this.state.newTag !== "") {
            let data = {le_id: this.state.vignet_id, tag_name: this.state.newTag};
            this.props.saveTags(data);

            this.setState({tagStatus: "Processing..."})
        }
    }

    saveNote() {
        if(this.state.textNote !== '') {
            let data = {userid : this.Auth.getProfile().user_id, vigid : this.state.vignet_id, note : this.state.textNote};
            this.props.saveNote(data);
        }

        this.setState({textNote : ''});
    }

    /************************Project ***************************/
    handleProjectDelete(i) {
        let projects  = this.state.projects;
        console.log(projects);
        if(projects) {

            let newProjects = projects.filter((project, index) => index !== i);
            this.setState({
                projects: newProjects
            });

            let data = {le_id : this.state.vignet_id, project_name : projects[i].text, projects: JSON.stringify(newProjects)};
            this.props.removeProjects(data);
        }

    }

    handleProjectAddition(project) {
        console.log(this.state.projects);
        this.setState(state => ({ projects: [...state.projects, project] }));

        let data = {le_id : this.state.vignet_id, project_name : project.text};
        this.props.saveProjects(data);

        this.setState({projectStatus : "Processing..."})
    }

    handleProjectDrag(project, currPos, newPos) {
        const projects = [...this.state.projects];
        const newProjects = projects.slice();

        newProjects.splice(currPos, 1);
        newProjects.splice(newPos, 0, project);

        // re-render
        this.setState({ projects: newProjects });
    }

    handleInputBlur(tagText) {
        console.log(this.state.tags);
        this.setState({ newTag: tagText });
    }
    /*************************Project End *************************/

    showSharePop() {
        this.setState({showShareOptions : !this.state.showShareOptions});
    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    cToggle() {
        this.setState({
            copyUrl: !this.state.copyUrl
        });
    }

    qToggle() {
        console.log(this.state.showQR);
        this.setState({
            showQR: !this.state.showQR
        });
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.Auth.getProfile().user_id;

        var e = document.createElement("textarea");
        var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {


        var baseUrl =String('https://a.vignets.com/player//'+vignet_id);

        let rootUrl = '';let shareUrl ='';


        if(type === 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type === 'wa') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type === 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }
        window.open(shareUrl,'_blank',"toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=400");

    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {
        this.setState({
            showQR : true
        });

    }

    downloadQRCode() {
        let vignet_id = this.state.vignet_id;
        var canvas = document.querySelector( 'canvas' );
        var link = document.createElement('a');
        link.innerHTML = 'Download';
        link.addEventListener('click', function(ev) {
            link.href = canvas.toDataURL();
            link.download = vignet_id+".png";
        }, false);
        document.body.appendChild(link);
        link.click();
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        //Request to purging
        this.props.getImagepurged({image_name : 'cf'+this.state.vignet_id, image_path : fileName});

    }

    toggle() {
        this.setState({
            showGraphMessage: !this.state.showGraphMessage,
            alertMessage : ''
        });
    }
    exportVignet() {

        const url = "https://devvigapiv1.vignets.com/builder/exporttext";
        const data = { vig_id : "5dc3fc707b39e", userid : "u5d4d1e8f76801"};

        fetch(url, {
            method: 'POST',
            supportHeaderParams: true,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin":"*"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.text())
            .then(
                (result) => {
                   console.log(result);
                },
                (error) => {
                    //console.log('Error - ' + error)
                }
            );

    }


    render() {console.log(this.props.playlistData.newImage)

        const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/{builderUrl}'/>;
        }

        let vignet = this.props.vignetsData.vignetDetail;

        console.log(this.state.tags);

       // let graphData =  this.props.vignetsData.graphData?this.props.vignetsData.graphData:[];

        let fbViewCount =  this.props.vignetsData.fbViewCount?this.props.vignetsData.fbViewCount:0;
        let waViewCount =  this.props.vignetsData.waViewCount?this.props.vignetsData.waViewCount:0;
        let fbShareCount =  this.props.vignetsData.fbShareCount?this.props.vignetsData.fbShareCount:0;
        let waShareCount =  this.props.vignetsData.waShareCount?this.props.vignetsData.waShareCount:0;


        let builderUrl = '';
        let playerUrl = '';
        let img_name = '';
        if(vignet ) {
            builderUrl = BUILDER_PATH+ vignet.vignet_id+'/'+this.Auth.getProfile().user_id;
            if(vignet.public_view === 1) {
                playerUrl = PUB_PLAYER_PATH+ vignet.vignet_id;
            }
            else{
                playerUrl = UNPUB_PLAYER_PATH+ vignet.vignet_id+'//';
            }
            img_name = vignet.vignet_id;
        }
        let profileImgSrc = IMGIX_PATH+'assets/slider/'+this.Auth.getProfile().user_id+'.jpg?q=' + Math.random() + '&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x'
        let imgSrc = IMGIX_PATH+'assets/slider/cf'+img_name+'.jpg?q=' + Math.random() + '&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';

       let vignetNotes = this.props.vignetsData.vignetNotes?this.props.vignetsData.vignetNotes:undefined;

       console.log(this.props.vignetsData);


        return (

            <div className="content-tab">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className="nav-link vign-ico active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                           aria-controls="home" aria-selected="true">Overview</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link any-ico" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                           aria-controls="profile" aria-selected="false">Analytics</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link res-ico" id="contact-tab" data-toggle="tab" href="#contact" role="tab"
                           aria-controls="contact" aria-selected="false">Responses</a>
                    </li>
                </ul>
                {!vignet &&
                <div className="loaderWrapper">
                    <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                </div>
                }

                {vignet &&
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div className="main-header-panel">
                            <div className="header-panel-left">

                                <div className="image-up">

                                    {this.state.image_path &&
                                    <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="vignet"/>
                                    }
                                    {this.state.image_path ===null &&
                                    <img src={imgSrc} alt="default" />
                                    }

                                    <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type="VIGNETS" unique_id = {(this.props.vignetsData && this.props.vignetsData.vignetDetail && this.props.vignetsData.vignetDetail.vignet_id) ? 'cf'+this.props.vignetsData.vignetDetail.vignet_id : ''} />
                                    {this.state.image_path ===null && this.props.uploadData.loader === true &&
                                    <div id="progress-bar-wrapper"></div>
                                    }
                                    {this.props.uploadData.errors === true &&
                                    <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                    }

                                </div>

                            </div>
                            <div className="header-panel-right">
                                <div className = {this.state.editTag ? "detail-left" : "detail-left non-edit"}>
                                    <h5>{vignet.vignet_title}</h5>
                                    <p>{vignet.description}</p>
                                    <ul className="info-txt">
                                        <li>{vignet.created_date}</li>
                                        <li>{vignet.user_name}</li>
                                        {vignet.category !== '' && vignet.category !== null &&
                                        <li>CATEGORY - {vignet.vig_category}</li>
                                        }
                                    </ul>
                                    <ul className="info-txt">
                                        {vignet.project_names !== '' &&
                                        <li>Projects - {vignet.project_names}</li>
                                        }
                                        {vignet.project_names !== '' &&
                                        <li className="ind-tag">
                                            <button onClick={() => this.editProjects()}
                                                    className="ico-lib edit-ico"></button>
                                        </li>
                                        }
                                    </ul>

                                    {!this.state.editProject && this.state.projects && this.state.projects.length  === 0 &&
                                    <div className="tag-main">
                                        <button className="tag-edit" onClick={() => this.editProjects()}>Add Projects</button>
                                    </div>
                                    }
                                    {this.state.editProject && this.state.projects &&
                                    <div className="tag-blck-btn">
                                        <ReactTags tags={this.state.projects}
                                                   handleDelete={this.handleDelete}
                                                   handleAddition={this.handleAddition}
                                                   handleDrag={this.handleDrag}
                                                   handleInputBlur ={this.handleInputBlur}
                                                   delimiters={delimiters}
                                                   placeholder={`Add new project`}/>
                                        <button className={this.state.editProject ? "tag-edit tag-btn-algn" : "tag-edit"} onClick={() => this.saveProjects()}>{this.state.tagStatus}</button>
                                        <button className="tag-edit  tag-btn-algn" onClick={() => this.cancelProjectEdit()}>Cancel</button>
                                    </div>
                                    }




                                    {!this.state.editTag && this.state.tags && this.state.tags.length > 0 &&
                                    <ul className="tag-block-edit">
                                        {this.state.tags &&
                                        this.state.tags.map((tag, index) =>
                                            <li className="ind-tag">#{tag.text}</li>
                                        )}
                                        {this.state.tags && this.state.tags.length > 0 &&
                                        <li className="ind-tag">
                                            <button onClick={() => this.editTags()}
                                                    className="ico-lib edit-ico"></button>
                                        </li>
                                        }
                                    </ul>
                                    }
                                    {!this.state.editTag && this.state.tags && this.state.tags.length  === 0 &&
                                    <div className="tag-main">
                                        <button className="tag-edit" onClick={() => this.editTags()}>Add Tags</button>
                                    </div>
                                    }
                                    {this.state.editTag && this.state.tags &&
                                    <div className="tag-blck-btn">
                                        <ReactTags tags={this.state.tags}
                                                   handleDelete={this.handleDelete}
                                                   handleAddition={this.handleAddition}
                                                   handleDrag={this.handleDrag}
                                                   handleInputBlur ={this.handleInputBlur}
                                                   delimiters={delimiters}/>
                                        <button className={this.state.editTag ? "tag-edit tag-btn-algn" : "tag-edit"} onClick={() => this.saveTags()}>{this.state.tagStatus}</button>
                                        <button className="tag-edit  tag-btn-algn" onClick={() => this.cancelEdit()}>Cancel</button>
                                    </div>
                                    }


                                </div>
                                <div className="detail-right">
                                    <div className="status-wrap">
                                        <div className="ind-status">
                                            <span>VIEWS</span>
                                            <h5>{vignet.eventTracks.view_count}</h5>
                                        </div>
                                        <div className="ind-status">
                                            <span>SHARES</span>
                                            <h5>{vignet.eventTracks.share_count}</h5>
                                        </div>
                                        <div className="ind-status">
                                            <span>CLICKS</span>
                                            <h5>{vignet.eventTracks.click_count}</h5>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="status-option-wrap">
                                <a href={builderUrl} target="_blank">
                                    <button className="status-option ico-lib option-edit"></button>
                                </a>
                                <a href={playerUrl} target="_blank">
                                    <button className="status-option ico-lib option-preview"></button>
                                </a>

                                {/*<button className="status-option ico-lib" onClick={this.exportVignet}>Export</button>-*/}

                                <button className="status-option ico-lib option-upload" onClick={()=>this.showSharePop()}
                                aria-controls="collapse-share-options"
                                    aria-expanded={this.state.showShareOptions} ></button>


                            <Collapse in={this.state.showShareOptions}>
                                <ul id="collapse-share-options" className="upload">
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib icon-face" onClick={() => {this.shareToFb('fb',vignet.vignet_id)}}>Facebook</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib icon-whatsapp" onClick={() => {this.shareToFb('wa',vignet.vignet_id)}}>Whatsapp</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib icon-email" onClick={() => {this.shareToFb('em',vignet.vignet_id, vignet.vignet_vignet_title)}}>Email</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib icon-embed" onClick={() => {this.showWebModal(vignet.vignet_id, vignet.vignet_vignet_title)}}>Copy Embed Code</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" className="icon-lib icon-qr" onClick={() => {this.showQRModal(vignet.vignet_id)}}>QR Code</a>
                                    </li>
                                </ul>
                                </Collapse>
                            </div>
                        </div>

                        <div className="note-wrapper">
                            <h5 className="note-header">Note</h5>
                            <div className="ind-note new-note-block">
                                <div className="ind-note-left">
                                    <img src={profileImgSrc} alt={profileImgSrc}/>
                                </div>
                                <div className="ind-note-right">
                                    <textarea placeholder="Drop a note to remind yourself." name="textNote" id="textNote" value={this.state.textNote}  onChange={this.handleInputChange} onBlur={() => this.saveNote()}></textarea>
                                </div>
                            </div>
                            {vignetNotes && vignetNotes.map((note, index) => {
                                let profileImgSrc = IMGIX_PATH+'assets/slider/'+note.pub_user+'.jpg?q=' + Math.random() + '&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x'
                                return(
                                    <div className="ind-note comment">
                                        <div className="added-comment-panel">
                                            <div className="added-comment-left">
                                                <div className="com-user-thumb">
                                                    <img src={profileImgSrc}/>
                                                </div>
                                                <div className="com-user-det">
                                                    <h5>{note.user_name}</h5>
                                                    <p>{note.publish_date}</p>
                                                </div>
                                            </div>
                                            <div className="added-comment-right">
                                                <p>&nbsp;</p>
                                            </div>
                                        </div>
                                        <div className="commented-text">
                                            <p>{note.pub_note}</p>
                                        </div>
                                    </div>
                                );
                            })
                            }

                        </div>
                    </div>

                    <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab"><Analytics />

                        <div className="vignet-detail-panel">
                                    <div className="sort-wraper">
                                        {/*<div className="dropdown custom-dropdown">
                                            <button className="filter-btn">Plot Rows</button>
                                            <label>Sort Type: </label>
                                            <button className="custom-drop dropdown-toggle" type="button" id="dropdownMenu2"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Default
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMenu2"
                                                 x-placement="bottom-start"
                                                 style={{
                                                     position: 'absolute',
                                                     transform: 'translate3d(46px, 34px, 0px)',
                                                     top: '0px',
                                                     left: '0px',
                                                     willChange: 'transform'
                                                 }}>
                                                <button className="dropdown-item" type="button">Default</button>
                                                <button className="dropdown-item" type="button">Modified Type A</button>
                                                <button className="dropdown-item" type="button">Modified Type B</button>
                                            </div>
                                        </div>*/}
                                        {/*  <div className="search-block">
                                            <input type="text" className="search-box" placeholder="Search"/>
                                            <button className="search-btn icon-lib search-ico"></button>
                                        </div>*/}

                                    </div>
                                </div>
                                <div className="vignet-table-block">
                                    <table className="table vignet-table">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Platform</th>
                                            <th>Views</th>
                                            <th>Shares</th>
                                            <th>Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {/*<div className="check-wrapper">
                                                    <input type="checkbox" name="vig-select" className="check-input"/>
                                                    <label className="check-lbl"></label>
                                                </div>*/}
                                            </td>
                                            <td>Facebook</td>
                                            <td>{fbViewCount}</td>
                                            <td>{fbShareCount}</td>
                                            <td>{fbViewCount+fbShareCount}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {/*<div className="check-wrapper">
                                                    <input type="checkbox" name="vig-select" className="check-input"/>
                                                    <label className="check-lbl"></label>
                                                </div>*/}
                                            </td>
                                            <td>Whatsapp</td>
                                            <td>{waViewCount}</td>
                                            <td>{waShareCount}</td>
                                            <td>{waViewCount+waShareCount}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>

                        </div>
                    <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
                </div>
                }
                {this.state.showPop &&

                    <Modal isOpen={this.state.showPop} toggle={this.mToggle} centered={true} >



                        {/*<div className="md-op">
                            <button type="button" className="close md-close" data-dismiss="modal" onClick={this.mToggle}></button>

                            <div className="share-block social-share">
                                <button className="share-button fb" title="Facebook" onClick={() => {this.shareToFb('fb',vignet.vignet_id)}}></button>
                                <button className="share-button wa" title="Whatsapp" onClick={() => {this.shareToFb('wa',vignet.vignet_id)}}></button>
                                <button className="share-button email" title="Email" onClick={() => {this.shareToFb('em',vignet.vignet_id, vignet.vignet_vignet_title)}}></button>
                                <button className="share-button web" title="Embeded Code" onClick={() => {this.showWebModal(vignet.vignet_id, vignet.vignet_vignet_title)}}></button>
                                <button className="share-button qr" title="QR Code" onClick={() => {this.showQRModal(vignet.vignet_id)}}></button>
                            </div>

                        </div>*/}
                    </Modal>
                }

                {this.state.copyUrl &&

                <Modal isOpen={this.state.copyUrl} toggle={this.cToggle} >
                    <ModalBody>
                        <div className="alert alert-danger text-center" role="alert">
                            The link copied to clipboard. {this.state.copyUrl}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.cToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }



                {this.state.showQR &&

                <Modal isOpen={this.state.showQR} toggle={this.qToggle} >
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            {vignet &&
                            <QRCode value={playerUrl}/>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.downloadQRCode}>Download</Button>
                        <Button color="secondary" onClick={this.qToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }

            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        vignetsData  :state.vignets.vignetsData,
        uploadData : state.upload.uploadData,
        playlistData  :state.playlist.playlistData,
    };

}
export default  withRouter(connect(mapStateToProps, {
    getDetail : vignetsActions.getVignetDetail,
    getVignetsProps : vignetsActions.getVignetProps,
    getVignetTags : vignetsActions.getVignetTags,
    getVignetNotes : vignetsActions.getVignetNotes,
    getVignetProjects : vignetsActions.getVignetProjects,
    saveTags : vignetsActions.saveTags,
    removeTags : vignetsActions.removeTags,
    saveNote : vignetsActions.saveNote,
    getImagepurged : playlistActions.purgeImage,

})(DetailContainer));



// WEBPACK FOOTER //
// ./src/components/vignets/DetailContainer.js